const _en = {};

_en.static = {
  'paymode.select.option': 'Select an option to pay',
  'paymode.select.other': 'Select from other options',
  'sc.select': 'SELECT A SAVED CARD',
  'got.it': 'Ok, Got It!',
  'select.option.to.pay.subscription': 'SELECT AN OPTION TO SUBSCRIBE'
};

_en.header = {
  'otp.send': 'OTP requested successfully',
  'order.id': 'Order ID',
  'select.option.pay': 'Select an option to pay',
  'select.option.to.pay.subscription': 'SELECT AN OPTION TO SUBSCRIBE',
  switch: 'Switch',
  account: 'Account'
};

_en.footer = {
  message: '100% Secure Payments Powered by Paytm'
};

_en.offers = {
  message: 'Exclusive Offers for You',
  termsAndCondition: 'Offer T&C',
  bankOffers: 'Bank Offers',
  validatePromoError: 'This transaction requires a valid promocode to proceed.',
  invalidTermsAndConditionUrl: 'Invalid terms and conditions URL.',
  instantDiscount: 'Instant discount of ₹amount applicable.',
  cashback: 'Cashback worth ₹amount applicable.',
  pwpPreLogin: "Bank offers won't be applicable after logging into Paytm."
};

_en.retry = {
  message: 'Retry',
  'payment.failed': 'Payment Failed',
  info: 'Please do not close this window or press back while we confirm your payment status'
};

_en.processing = {
  heading: 'Processing Your Payment',
  info: 'Please do not close this window or press back while we confirm your payment status'
};

_en.card = {
  number: 'Card Number',
  expiry: 'Expiry / Validity',
  cvv: 'CVV',
  'save.card': 'Save this card for future payments',
  'invalid.card.number': 'Please enter valid card number',
  'invalid.expiry': 'Invalid Expiry Date',
  'invalid.cvv': 'Please enter valid CVV'
};

_en.ppbl = {
  'check.balance': 'Check Balance',
  'available.balance': 'Available Balance ₹ ',
  'insufficient.balance': 'You do not have enough balance for this payment',
  'invalid.passcode': 'Enter valid passcode',
  enterPasscode: 'Enter passcode'
};

_en.qr = {
  pay: 'Scan QR to Pay',
  'scan.qrcode': 'Scan QR code using your Paytm app',
  'scan.qrcode.upi': 'Scan QR code using Paytm or your preferred UPI app',
  'scan.upi.qrcode': 'Scan QR code using Paytm or your preferred UPI app to complete payment',
  'scan.upi.payment': 'Payment will be completed on that app',
  'scan.paytm': 'You will be able to pay using any of your saved payment options',
  'scan.upi': 'Scan with your Paytm app to pay using UPI or any of your saved payment options',
  'all.apps': 'All other apps will only have UPI as payment option',
  'click.enlarge': 'Click to enlarge',
  'prn.incorrect': 'Enter the correct Payment Reference No.',
  'prn.description': 'It is an 8 digit no. displayed on payment confirmation screen in your APP',
  prn: 'Enter Paytm reference number',
  'process.payment': 'Processing Payment',
  'process.redirect':
    'You will be redirected once the payment is successful on your {{UPI_APP}} App',
  'process.press.btn': 'Please do not press back button until payment is completed',
  reload: 'Click to Reload QR',
  'scan.pending':
    'It seems your transaction has moved into pending state.You can retry or wait for the transaction to complete. In case of retry, you will be charged only for one transaction even if the first transaction successfully completes after sometime'
};

_en.pdc = {
  'check.balance': 'Check Balance',
  'available.balance': 'Available Balance ₹ ',
  'insufficient.balance': 'You do not have enough balance for this payment'
};

_en.savedCard = {
  'label.viewMore': 'View All Saved Cards',
  'label.viewLess': 'View Less',
  'label.invalidCvv': 'Invalid CVV'
};

_en.upi = {
  'select.upi': 'Select Your UPI App',
  'handler.suggestion': 'OR Enter Your UPI ID',
  'id.required': 'Please enter a UPI ID',
  'invalid.id': 'Please enter a valid UPI ID',
  title: `Pay using your UPI ID`,
  'title.desc': `Enter your UPI ID and approve the payment request on the app linked to it.`,
  'polling.default.goto': `UPI linked Bank/ UPI mobile application`,
  'polling.approve': `Check pending requests and approve payment by entering UPI PIN`,
  'polling.click': `If the UPI address belongs to your friend/ family, they will need to approve the payment request on thier UPI linked bank application`,
  'polling.noback': `Please do not press back button until payment is completed`,
  'subscription.error':
    'The UPI ID entered does not support subscription payments. Please try with another UPI ID.'
};

_en.nb = {
  'secure.redirection.message': `You will be redirected to bank's website for secure payment processing`,
  'no.result.found': 'No Result Found'
};

_en.login = {
  message: 'Pay using your saved payment instruments',
  'otp.sent.number': 'Enter OTP sent to mobile number',
  'invalid.otp.length': 'Please Enter Valid Otp',
  'invalid.mobile.input': 'Please Enter a valid mobile number',
  'otp.not.received': "Didn't receive OTP?",
  'request.otp': 'Request Another OTP',
  rememberMe: 'Remember Me',
  'btn.sendOtp.text': 'Proceed',
  'btn.verifyOtp.text': 'Verify',
  'subscription.msg':
    'Use your wallet balance, saved payment options & keep track of your subscription',
  'mobile.number': 'Mobile no.',
  'change.number': 'Change'
};

_en.wallet = {
  'insufficient.balance': 'You do not have enough balance for this payment'
};

_en.mgv = {
  'insufficient.balance': 'You do not have enough balance for this payment'
};

_en.payButton = {
  text: 'PAY ₹',
  addNPayText: 'Add ₹amount & Pay',
  effectivePrice: '(Effective price: ₹effectPrice with ₹amount cashback)'
};

_en.emiErrors = {
  emiBankListErrorHeading: 'EMI option is not available on this bank',
  emiBankListErrorSubtext: 'Select other banks to avail EMI',
  emiPlanError: 'Unable to apply Plan',
  emiPlanSubtext: 'Select other plan to avail EMI',
  errorBtn: 'OK , Got it',
  emiPlanSelectError: 'Select EMI Plan',
  emiNotAvailable: 'EMI not available on this card. Please choose another card'
};
_en.emi = {
  interest: 'Interest as per the plan will be applicable on each product',
  emiConvert: 'Your bank will convert your payment into EMI in 3-4 working days',
  cashback: 'Cashback, if any, will be credited to you in 45 days post order delivery',
  kycText:
    'Kindly get your KYC done to receive cashback in your Paytm wallet. Please ignore if already done',
  emiHybridDisabledText: 'Paytm Balance and EMI cannot be used together for this payment',
  emiHybridDisabledCardText:
    'Paytm Balance and EMI cannot be used together for this payment. Please select your Emi Again'
};

_en.subscription = {
  savedCard: 'This card will be saved for future payments',
  details: 'Subscription Details',
  viewDetails: 'View Subscription Details',
  upto: 'upto',
  'merchant.shared': 'As shared by',
  'may.be.deducted': 'may be charged by your bank for verification'
};

_en.pcf = {
  inclusive: 'Inclusive of ',
  'convenience.gst': 'Convenience Charge + GST',
  'apx.amount': 'Approximate amount',
  applicable: 'as applicable',
  'convenience.charge': 'Convenience Charges',
  convenience: 'Convenience',
  'error.heading': 'Unable to fetch convenience charges',
  'error.desc':
    'We could not fetch convenience charges for payment using <placeholder>. Please use another option to complete payment',
  'error.web.desc': 'Please use another option to complete payment',
  'error.web.heading': 'We could not fetch convenience charges for payment using <placeholder>.',
  'error.web.heading1': 'We could not fetch convenience fee.  Please try again.',
  'amount.vary': 'Amount may vary from bank to bank',
  nb: 'Amount may vary from bank to bank',
  cc: 'Amount may vary based on card scheme'
};

/** bank mandate */
_en.bm = {
  'enter.number': 'Enter Bank Account Number',
  'invalid.number': 'Please enter a valid bank account number',
  'blank.number': 'Please enter your bank account number',
  'enter.name': 'Enter your name (As per Bank Records)',
  'invalid.name': 'Please enter a valid name',
  'blank.name': 'Please enter your name',
  'enter.ifsc': 'Enter IFSC',
  'invalid.ifsc': 'Please enter a valid IFSC',
  'blank.ifsc': 'Please enter your bank IFSC',
  'find.ifsc': 'Find IFSC',
  'blank.auth': 'Please choose authenticate mode',
  'authenticate.using': 'Authenticate Using',
  'account.saving': 'Savings Account',
  'confirm.NET_BANKING':
    'You will be asked to login to your netbanking account by your bank to confirm the mandate request',
  'confirm.DEBIT_CARD':
    'You will be asked to enter your debit card details by your bank to confirm the mandate request',
  'change.bank': 'Change Bank',
  'auth.using': 'Authenticate Using',
  proceed: 'Proceed',
  confirm: 'Confirm',
  'select.other.bank': 'Select from all other banks',
  'search.state': 'Search State',
  'search.city': 'Search City',
  'search.bank': 'Search Bank',
  'select.state': 'Select State',
  'select.city': 'Select City',
  'select.bank': 'Select your Bank',
  'subscription.details': 'Subscription Details',
  'customer.name': 'Customer Name',
  frequency: 'Frequency',
  'max.amount': 'Maximum Amount',
  'start.date': 'Start Date',
  'exp.date': 'Expiry Date',
  purpose: 'Purpose',
  'bank.acc.details': 'Bank Account Details',
  'ifsc.code': 'IFSC Code',
  'savings.acc': 'Savings Account',
  'mandate.powered': 'E-mandate Powered by',
  'ac.no': 'A/C No.',
  'until.cancelled': 'Until Cancelled',
  'subs.on.demand': 'As and When Presented',
  'amt.deduct': 'Will be deducted within 2-4 days'
};

/** UPI Intent */
_en.upi_intent = {
  'help.step1': `Click on Pay button to open the list of UPI apps installed on your mobile`,
  // "help.step1": `Select the option "UPI Apps" on Paytm Payments Page. On proceeding, you will see a list of active UPI Apps on your device`,
  'help.step2':
    'On selecting your preferred UPI App, you will be taken to the app to complete the payment',
  'help.step3':
    'After completing your payment, you will be redirected back to the payment confirmation screen',
  'help.title': 'How to Pay Using UPI Apps',
  label: 'Pay using a UPI App',
  'paymode.label': 'Pay Using UPI Apps',
  help: 'Know More',
  desc: 'Click the Pay button to select from the list of apps available on your mobile',
  'psp.not.found': 'Unable to process your payment. Please retry using any other paymode',
  'loader.heading': 'Fetching UPI Apps',
  'loader.desc': 'Please wait while we fetch the list of UPI Apps installed on your mobile',
  'loader.retry.heading': `Awaiting Response`,
  'loader.retry.desc': `The response from your UPI app is taking longer than ususal. Please wait or click on try again`,
  'loader.retry.validation.heading': `Validating`,
  'loader.retry.validation.desc': `Please wait while we fetch the final payment status before you try again`
};

/* DirectBank */
_en.dBank = {
  paymentDetails: 'Payment Details',
  completePayment: 'Complete Payment',
  otp: 'An OTP has been sent to your registered mobile number',
  enterOtp: 'Enter OTP',
  requestAnotherOtp: 'Request Another OTP',
  cancel: 'Cancel',
  notReceivedOtp: 'Still did not receive OTP?',
  otpMissing: 'OTP Missing',
  otpIncomplete: 'OTP Incomplete',
  resendOtp: 'Resend OTP',
  cancelPayment: 'Cancel Payment',
  questionCancel: 'Why do you want to cancel this payment?',
  wantBank: 'Want to complete this payment on Bank website',
  goBank: 'Go to Bank Website',
  notBuy: 'Do not want to buy this product/service anymore',
  notRegistered: 'Do not have access to registered mobile number',
  submit: 'Submit',
  issueOtp: 'Facing issue with OTP page',
  other: 'Other',
  paytm: 'Paytm'
};

export default _en;



// WEBPACK FOOTER //
// ./locale/en.js